(($)=>{
	if(window.tippy){
		tippy('[data-tippy-content]',
			{
				// appendTo: 'parent',
				allowHTML: true,
				content: (reference) => {
					const title = reference.getAttribute('data-tippy-content');
					let content = `<div class="tippy-variant__option-title">${title}</div>`;
					if (reference.classList.contains('variant-unavailable') ){
						content = `<div class="tippy-variant__option-title">${title}</div> <div class="tippy-variant__option-title-soldout">Sold Out</div>`;
					}
					return content;
				},
				arrow: tippy.roundArrow,
				// trigger: 'click',
				// hideOnClick: 'toggle',
				ignoreAttributes: true,
			}
		);
	}
})(jQuery)